module.exports = __webpack_public_path__ + "img/filter-range.4f0e99a.png";